/**
 * StepButton - 前日/翌日・前月/翌月など1ステップ移動用の矢印付きナビゲーションボタン
 *
 * スタイルは常に同一のため内部で固定している。
 * ラベルとクリックハンドラだけ渡して使う。
 *
 * @param {string}   label    - 表示テキスト (例: '◀ 前日', '翌月 ▶')
 * @param {function} onClick  - クリックハンドラ
 * @param {boolean}  disabled - true のとき非活性化する（未来日付制限等）
 */
function StepButton({ label, onClick, disabled = false }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`mx-2 px-3 py-2 text-lg border rounded shadow-sm ${
        disabled
          ? "border-gray-300 text-gray-300 cursor-not-allowed"
          : "border-gray-400 active:shadow-none active:translate-y-px cursor-pointer"
      }`}
    >
      {label}
    </button>
  );
}

export default StepButton;
